'use strict'

export * from './banner'
export * from './georgia'
export * from './gallery/index'
export * from './feedBacks'
export * from './aboutUs/index'
export * from './contact'
export * from './tours/index'
